var range = function range(start, end) {
  return Array(end - start + 1).fill().map(function (_, idx) {
    return start + idx;
  });
};

export { range };
//# sourceMappingURL=arrays.js.map
